import Image from 'next/image';
import React, { useEffect, useMemo } from 'react';
import { getCategoryInfo } from '../config/categoryMapping';

const preloadImages = (urls) => {
  if (typeof window === 'undefined') return;
  urls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

const CategoryIcon = React.memo(
  ({
    categoryName,
    size = 'xl',
    onClick,
    className = '',
    style = {},
    showTooltip = false,
    normalCleaning = true,
    preload = false
  }) => {
    const categoryInfo = useMemo(
      () => getCategoryInfo(categoryName, normalCleaning),
      [categoryName, normalCleaning]
    );

    useEffect(() => {
      if (preload && categoryInfo?.icon) preloadImages([categoryInfo.icon]);
    }, [preload, categoryInfo.icon]);

    const sizeClasses = {
      sm: 'w-8 h-8',
      md: 'w-12 h-12',
      lg: 'w-16 h-16',
      xl: 'w-20 h-20'
    };

    const iconSizeClasses = {
      sm: 'w-6 h-6',
      md: 'w-8 h-8',
      lg: 'w-12 h-12',
      xl: 'w-14 h-14 xs:w-16 xs:h-16 sm:w-20 sm:h-20'
    };

    const iconSrc = categoryInfo.icon?.trim();

    return (
      <div
        className={`flex items-center justify-center rounded-lg ${sizeClasses[size]} ${className}`}
        style={style}
        title={showTooltip ? categoryInfo.displayName : undefined}
        onClick={onClick}
      >
        <img
          src={iconSrc}
          alt={categoryInfo.displayName}
          className={`${iconSizeClasses[size]} object-contain cursor-pointer`}
          width={100}
          height={100}
          
          loading="lazy"
        />
      </div>
    );
  }
);

export default CategoryIcon;
